import React from "react";
import { Typography, Button } from "antd";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;

export default function Invoce() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "30px",
        border: "1px solid black",
      }}
    >
      <Title level={2} style={{ marginBottom: "20px" }}>
        Invoice
      </Title>
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid gray",
          borderTop: "1px solid gray",
        }}
      >
        <div style={{ flex: "2" }}>
          <Title
            level={4}
            style={{
              marginBottom: "30px",
              fontSize: "22px",
              marginTop: "20px",
            }}
          >
            Invoice details
          </Title>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ flex: "1", textAlign: "center" }}>
              <p style={{ marginBottom: "20px" }}>Customer name: Shisong</p>
              <p style={{ marginBottom: "20px" }}>12 Oakwood Avenue</p>
              <p style={{ marginBottom: "20px" }}>Southampton</p>
              <p style={{ marginBottom: "20px" }}>United Kindom</p>
              <p style={{ marginBottom: "20px" }}>SE10 4DH</p>
            </div>
            <div style={{ flex: "1", textAlign: "center" }}>
              <p style={{ marginTop: "5px", marginBottom: "20px" }}>
                <strong>Order id: 6</strong>
              </p>
              <p style={{ marginBottom: "20px" }}>
                <strong>Date: 10/05/2023</strong>
              </p>
              <p style={{ marginBottom: "20px" }}>
                <strong>Status: processing</strong>
              </p>
            </div>
          </div>
        </div>
        <div style={{ flex: "1", borderLeft: "1px solid gray" }}>
          <Title
            level={4}
            style={{
              marginBottom: "30px",
              fontSize: "22px",
              marginTop: "20px",
            }}
          >
            Delivery details
          </Title>
          <div style={{ textAlign: "center" }}>
            <p style={{ marginTop: "15px", marginBottom: "20px" }}>Shisong</p>
            <p style={{ marginBottom: "20px" }}>12 Oakwood Avenue</p>
            <p style={{ marginBottom: "20px" }}>Southampton</p>
            <p style={{ marginBottom: "20px" }}>SE10 4DH</p>
          </div>
        </div>
      </div>
      <Title level={4} style={{ marginTop: "20px", fontSize: "22px" }}>
        Order details
      </Title>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
            borderBottom: "1px solid gray",
          }}
        >
          <div style={{ flex: "1" }}>
            <p style={{ marginBottom: "30px" }}>
              <strong>Product details</strong>
            </p>
            <p style={{ marginBottom: "20px" }}>
              Product Name : Dog Walking Services
            </p>
            <p style={{ marginBottom: "20px" }}>Product Type : Pet</p>
            <p style={{ marginBottom: "20px" }}>Product Area : Southampton</p>
            <p style={{ marginBottom: "40px" }}>Seller : Alice</p>
          </div>
          <div style={{ flex: "1" }}>
            <p style={{ marginBottom: "30px" }}>
              <strong>Quantity</strong>
            </p>
            <p>1</p>
          </div>
          <div style={{ flex: "1" }}>
            <p style={{ marginBottom: "30px" }}>
              <strong>Price</strong>
            </p>
            <p>£50.99</p>
          </div>
          <div style={{ flex: "1" }}>
            <p style={{ marginBottom: "30px" }}>
              <strong>Total</strong>
            </p>
            <p>£50.99</p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            style={{
              margin: "0 30px",
              backgroundColor: "#ff8a00",
              fontSize: "20px",
              width: "220px",
              height: "40px",
              marginTop: "30px",
            }}
          >
            Continue Shopping
          </Button>
          <Button
            type="primary"
            style={{
              margin: "0 30px",
              backgroundColor: "#ff8a00",
              fontSize: "20px",
              width: "220px",
              height: "40px",
              marginTop: "30px",
            }}
          >
            Print Invoice
          </Button>
          <Button
            type="primary"
            onClick={() => navigate("/account/order")}
            style={{
              margin: "0 30px",
              backgroundColor: "#ff8a00",
              fontSize: "20px",
              width: "220px",
              height: "40px",
              marginTop: "30px",
            }}
          >
            Back to My Order
          </Button>
        </div>
      </div>
    </div>
  );
}
